import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import {
  shortData,
  shortDate,
} from '../../helpers';
import CustomTable from '../../components/CustomTable/CustomTable';
import { RowAction, RowActions } from '../../components/RowActions/RowActions';

const columns = [
  {
    id: 'Id', label: 'Id',
  },
  {
    id: 'name', label: 'Name',
  },
  {
    id: 'Description', label: 'Description',
  },
  {
    id: 'CreatedDate',
    label: 'Created Date',
  },
  {
    id: 'UpdatedDate',
    label: 'Updated Date',
  },
  {
    id: 'action',
    label: 'Action',
  },
];

const useStyles = () => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  tablewo: {
    cursor: 'pointer',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  mainContainer: {
    // The page container (components/PageContainer) owns padding and width.
    width: '100%',
    minWidth: 0,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    margin: 20,
  },
  buttonLink: {
    width: 20,
    height: 20,
    margin: 0,
    padding: 10,
  },
});

class table extends Component {
  render() {
    const {
      classes, handleShowEditForm, data,
      handleChangePage, handleChangeRowsPerPage, handleShowAddForm,
      //  handleViewLoanDetails,
    } = this.props;

    return (
      <div className={classes.mainContainer}>
        <CustomTable
          tableClass={{ width: '50%' }}
          icons={[{ icon: AddCircleOutlineRoundedIcon, name: 'Add Report Type' }]}
          tableName="Report's Type"
          onIconClick={(key) => {
            handleShowAddForm(key);
          }}
          tableHead={columns}
          itemComponent={data.length > 0 ? data.map((element, index) => (
            <TableRow
              className={classes.tablewo}
              tabIndex={-1}
              key={element.id}
              // onClick={(key) => { handleViewLoanDetails(key, element.id); }}
            >
              <TableCell>
                {index + 1}
              </TableCell>
              <TableCell>
                {shortData(element.name || '')}
              </TableCell>
              <TableCell>
                {shortData(element.description || '')}
              </TableCell>
              <TableCell>
                {shortDate(element.createdAt || '')}
              </TableCell>
              <TableCell>
                {shortDate(element.updatedAt || '')}
              </TableCell>
              <TableCell>
                <RowActions>
                  <RowAction kind='edit' onClick={(key) => { handleShowEditForm(key, element); }} />
                </RowActions>
              </TableCell>
            </TableRow>
          )) : null}
          count={1}
          rowsPerPage={0}
          page={1}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export default withStyles(useStyles)(table);
